import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { componentKey, setLoadingStates, setUSPSMailToRecipientFees } from "./USPSMailToRecipientSlice";
import { USPS_MAIL_TO_RECIPIENT_LOADING_STATES } from "./constants";
import ManageFormsService from "../../../../../../services/ManageFormsService";
import { addNotifications } from "../../../../toaster/ToasterPortalSlice";
import { setUspsMailToRecipientsCreditCardModal } from "../ManageFederalFormsSlice";

export const { getUSPSMailFee } = {

    getUSPSMailFee: (payload) => {
        return {
            type: "USPS_MAIL_TO_RECIPIENT/GET_FEES",
            payload
        }
    },
}

function* getUSPSMailFeeAsync(action) {
    try {
        yield put(setLoadingStates({ state: USPS_MAIL_TO_RECIPIENT_LOADING_STATES.USPS_MAIL_FEE_LOADING }))
        const response = yield ManageFormsService.getUSPSMailFee(action?.payload);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setUSPSMailToRecipientFees(Data));
            yield put(setUspsMailToRecipientsCreditCardModal(true))
        } else {
            yield put(addNotifications({ heading: "Failed to get federal forms", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to get federal forms", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingStates({ state: USPS_MAIL_TO_RECIPIENT_LOADING_STATES.USPS_MAIL_FEE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getUSPSMailFee().type, getUSPSMailFeeAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);